<template>
	<div class="data-chooser d-flex justify-content-between align-items-center">
		<select class="form-select form-select-sm" v-model="data.value">
			<option value="">Select</option>
			<option :key="item.id" v-for="item in items" :value="item.id">{{ item.title || item.name }}</option>
		</select>
	</div>
</template>

<script>
import juniperAPI from '../../../../api/juniperApi'
export default {
	name: 'DataChooser',
	props: ['data'],
	data() {
		return {
			items: [],
		}
	},
	computed: {},
	watch: {
		'data.value': function() {
			this.$emit('change')
		},
	},
	created() {
		this.getData()
	},
	methods: {
		getData() {
			let params = {
				client_id: this.$route.params.id,
				per_page: 1000,
			}
			juniperAPI
				.get('/pages', { params })
				.then(({ data }) => {
					console.log(data)
					this.items = data
				})
				.catch(error => {
					console.log(error)
				})
		},
	},
	emits: ['change'],
}
</script>
<style scoped></style>
